/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import {
  Select,
  MyMessage,
  InputField,
  MyButton,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import {
  FOLDERS,
  image_kit_folder,
  isKeyHasAnEmptyValue,
} from "../utils/Utils";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import GenerateFullContentData from "../utils/GenerateContent";
import { useAdminContext } from "../../../context/admin/AdminContext";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import { FaHandSparkles } from "react-icons/fa";
import { FiImage, FiCalendar, FiDollarSign } from "react-icons/fi";

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(null);
  const [venue, setVenue] = useState(null);
  const [venueCapacity, setVenueCapacity] = useState<any>(0);
  const [repeatEvery, setRepeatEvery] = useState<any>(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [email, setEmail] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");
  const [hashtags, setHashtags] = useState("");
  const [googleMapCode, setGoogleMapCode] = useState("none");
  const [latitude, setLatitude] = useState("none");
  const [longitude, setLongitude] = useState("none");
  const [formattedAddress, setFormattedAddress] = useState(null);
  const [featured, setFeatured] = useState<any>("no");
  const [promoted, setPromoted] = useState<any>("no");
  const [eventStatus, setEventStatus] = useState(1);
  const [description, setDescription] = useState(null);
  const [expo, setExpo] = useState(0);
  const [showTop, setShowTop] = useState(0);
  const [pricing, setPricing] = useState<any[]>([]);
  const [payLink, setPayLink] = useState(null);

  const objectStructure = {
    thumbnail: "",
    thumbnailId: "",
    title: "",
    venue: "",
    venueCapacity: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    email: "",
    phoneNumber: "",
    whatsapp: "",
    facebook: "",
    twitter: "",
    instagram: "",
    youtube: "",
    hashtags: "",
    googleMapCode: "",
    latitude: "",
    longitude: "",
    formattedAddress: "",
    description: "",
    pricing: [{ currency: "", name: "", amount: 0, quantity: 1, status: 1 }],
  };

  const [showGenerateContent, setShowGenerateContent] = useState(false);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const eventRoutes = "/data/event";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setTitle(null);
    setVenue(null);
    setVenueCapacity(null);
    setThumbnail(null);
    setThumbnailId(null);
    setStartDate(null);
    setEndDate(null);
    setStartTime(null);
    setEndTime(null);
    setRepeatEvery(null);
    setExpo(0);
    setEmail(null);
    setPhoneNumber(null);
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");
    setHashtags("none");
    setGoogleMapCode("none");
    setLatitude("none");
    setLongitude("none");
    setFormattedAddress(null);
    setFeatured(0);
    setShowTop(0);
    setDescription(null);
    setPricing([]);
    setPayLink(null);
  };

  const responses = (error: any, message: any) => {
    setError(error);
    setLoading(false);
    setSuccess(!error);
    setErrorMessage(message);
  };

  const addOneEventHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: (title as any)?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      city_level: "city",
      venue: venue,
      venue_capacity: String(venueCapacity),
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: `${String(phoneNumber)?.replace(/\s+/g, "")}`,
      email_address: email,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: `${tags}, ${hashtags}`,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: eventStatus,
      featured: featured,
      promoted: promoted,
      repeat_every:
        repeatEvery ||
        "monday|tuesday|wednesday|thursday|friday|saturday|sunday",
      expo: expo,
      show_top: showTop,
      pricing,
      pay_link: payLink,
    };

    const { status, message } = await createOneContent({
      data: data,
      content: _TYPES_.EVENT,
    });
    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  const dayOptions = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
    "annual",
  ];

  const toggleRepeat = (val: string) => {
    const parts = (repeatEvery || "").toString().split("|").filter(Boolean);
    if (parts.includes(val)) {
      setRepeatEvery(parts.filter((d: string) => d !== val).join("|"));
    } else {
      setRepeatEvery([...parts, val].join("|"));
    }
  };

  return (
    <AddPageShell
      backRoute={eventRoutes}
      eyebrow="DoSee Data • Events"
      title="Add Event"
      subtitle={`Promote a happening in ${entry_label || "this destination"}.`}
      icon={<FiCalendar className="h-5 w-5" />}
      modals={
        <>
          {showGenerateContent ? (
            <GenerateFullContentData
              type="event"
              setShowModal={setShowGenerateContent}
              structure={objectStructure}
              onGenerated={(content: any) => {
                setThumbnail(content?.image?.image_kit_url);
                setThumbnailId(
                  isKeyHasAnEmptyValue(content?.image?.image_kit_file_id)
                );
                setTitle(isKeyHasAnEmptyValue(content?.title));
                setVenue(isKeyHasAnEmptyValue(content?.venue));
                setVenueCapacity(parseInt(content?.venueCapacity) || 2);
                setStartDate(
                  isKeyHasAnEmptyValue(
                    content?.startDate,
                    new Date().toDateString()
                  )
                );
                setEndDate(
                  isKeyHasAnEmptyValue(
                    content?.endDate,
                    new Date().toDateString
                  )
                );
                setStartTime(isKeyHasAnEmptyValue(content?.startTime, "00:00"));
                setEndTime(
                  isKeyHasAnEmptyValue((content?.endTime, "00:00") as any)
                );
                setEmail(
                  isKeyHasAnEmptyValue(content?.email, "info@doseeafrica.com")
                );
                setPhoneNumber(
                  `${String(content?.phoneNumber).replace(/\D/g, "")}` as any
                );
                setPayLink(content?.pay_link);
                setWhatsapp(content?.whatsapp);
                setFacebook(content?.facebook);
                setTwitter(content?.twitter);
                setInstagram(content?.instagram);
                setYoutube(content?.youtube);
                setHashtags(content?.hashtags);
                setGoogleMapCode(content?.googleMapCode);
                setLatitude(content?.latitude);
                setLongitude(content?.longitude);
                setFormattedAddress(content?.formattedAddress);
                setDescription(content?.description);
                setPricing(
                  content?.pricing?.length > 0 ? content?.pricing : []
                );
                setRepeatEvery(
                  "monday|tuesday|wednesday|thursday|friday|saturday|sunday"
                );
              }}
            />
          ) : null}

          {showDescriptionModal ? (
            <GenerateDescription
              setDescription={setDescription}
              setShowDescriptionModal={setShowDescriptionModal}
            />
          ) : null}
        </>
      }
      headerActions={
        isSuperAdmin ? (
          <MyButton
            onClick={() => setShowGenerateContent(true)}
            className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-br from-brand to-primary px-3 py-2 text-xs font-semibold text-white shadow hover:opacity-95"
          >
            <FaHandSparkles className="h-4 w-4" />
            Generate Event
          </MyButton>
        ) : null
      }
      loading={loading}
      submitLabel="Add Event"
      onSubmit={addOneEventHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="The hero shot promoting this event."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.EVENTS)}
        />
      </AddSection>

      <AddSection
        title="Event Details"
        hint="Title, venue, capacity and a 'top events' flag."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              required: true,
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "top",
              title: "Show In Top Events",
              option: ["no", "yes"],
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setShowTop(0);
                else setShowTop(1);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue_capacity",
              title: "Venue Capacity",
              type: "number",
              value: venueCapacity || "",
              onChange: (e: any) => {
                setVenueCapacity(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="Schedule and recurring days."
        icon={<FiCalendar className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            props={{
              id: "start_date",
              title: "Start Date",
              type: "date",
              value: startDate || "",
              onChange: (e: any) => {
                setStartDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_date",
              title: "End Date",
              type: "date",
              value: endDate || "",
              onChange: (e: any) => {
                setEndDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "start_time",
              title: "Start Time",
              type: "time",
              value: startTime || "",
              onChange: (e: any) => {
                setStartTime(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_time",
              title: "End Time",
              type: "time",
              value: endTime || "",
              onChange: (e: any) => {
                setEndTime(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
        <div className="mt-5">
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
            Repeat Every
          </p>
          <div className="flex flex-wrap gap-3">
            {dayOptions.map((val) => {
              const selected = (repeatEvery || "")
                .toString()
                .split("|")
                .includes(val);
              return (
                <button
                  key={val}
                  type="button"
                  onClick={() => toggleRepeat(val)}
                  className={[
                    "inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium capitalize transition",
                    selected
                      ? "border-brand bg-brand/10 text-brand"
                      : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50",
                  ].join(" ")}
                >
                  {selected ? (
                    <MdCheckBox className="h-4 w-4" />
                  ) : (
                    <MdCheckBoxOutlineBlank className="h-4 w-4" />
                  )}
                  {val}
                </button>
              );
            })}
          </div>
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Tickets and tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="event_status"
        setStatus={setEventStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        clearMessages={clearMessages}
      />

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Add;
